export const getAlertSubSteps = (mode, subSteps = []) => {
  return subSteps.map((sub) => {
    if (sub.key === "billing") {
      return {
        ...sub,
        status: mode === "billing" ? "active" : "done"
      }
    }

    if (sub.key === "bin") {
      return {
        ...sub,
        label: mode === "arn" ? sub.arnLabel : sub.binLabel,
        status: mode === "billing" ? "wait" : "active"
      }
    }

    return sub
  })
}
